module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_home"
  }, [_c('div', {
    attrs: {
      "id": "dzfppz"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: " weui-fp",
    class: _vm.borderClass
  }, [(_vm.dataDetail.invoiceBaseInfo.invoiceKind === '10') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/fp2.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '04') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/fp22.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '01') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/zhuanyong.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '9') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/qklfp.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '08') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/dzzp.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '81') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": require("../../assets/img/qdzp.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '82') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/qdpp.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fpnr"
  }, [_c('p', [_c('label', [_vm._v("购买方名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceBuyerName))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("销售方名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceSellerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "fpnr",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [(!(_vm.dataDetail.invoiceBaseInfo.invoiceKind === '81' || _vm.dataDetail.invoiceBaseInfo.invoiceKind === '82')) ? _c('p', [_c('label', [_vm._v("发票代码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceCode))])]) : _vm._e(), _vm._v(" "), (!(_vm.dataDetail.invoiceBaseInfo.invoiceKind === '81' || _vm.dataDetail.invoiceBaseInfo.invoiceKind === '82')) ? _c('p', [_c('label', [_vm._v("发票号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceNo))])]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '81' || _vm.dataDetail.invoiceBaseInfo.invoiceKind === '82') ? _c('p', [_c('label', [_vm._v("全电发票号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceNo))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('label', [_vm._v("开票日期")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateFilter")(_vm.dataDetail.invoiceBaseInfo.invoiceDate, 'yyyy-MM-dd')))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("价税合计")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm._f("currencyFilter")(_vm.dataDetail.invoiceBaseInfo.invoiceTotalAmount, 2)))])]), _vm._v(" "), _c('p', [_c('label', {
    staticStyle: {
      "letter-spacing": "0.5em"
    }
  }, [_vm._v("校验码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceCheckCode))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('label', {
    staticStyle: {
      "letter-spacing": "2em"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceRemark))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_vm._v("开票明细")]), _vm._v(" "), _c('div', {
    staticClass: "weui-fp1"
  }, _vm._l((_vm.dataDetail.invoiceValueDetails), function(item) {
    return _c('p', [_c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "70%",
        "float": "left"
      }
    }, [_c('label', [_vm._v("\n                            " + _vm._s(item.name) + "\n                            "), (item.isZk) ? _c('span', {
      staticStyle: {
        "margin-left": "3px",
        "display": "inline-block",
        "color": "#FFF",
        "background-color": "#3f8ee3",
        "float": "none",
        "border-radius": "3px",
        "padding": "0 3px"
      }
    }, [_vm._v("折扣")]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("￥" + _vm._s(_vm._f("currencyFilter")((item.money + item.taxAmount), 2)))])])
  }), 0), _vm._v(" "), (_vm.win.ADurl) ? _c('div', {
    staticStyle: {
      "height": "33px"
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.win.ADurl
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "inset": "auto 100px 140px auto",
      "position": "fixed",
      "overflow": "hidden",
      "z-index": "9999",
      "display": "block"
    },
    attrs: {
      "id": "hdgg_entrance_element1"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": _vm.win.ADImgUrl
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "queding",
    staticStyle: {
      "min-height": "80px",
      "position": "static",
      "padding-top": "5px"
    }
  }, [(_vm.dataDetail.source === 'piaotong') ? _c('div', {
    staticStyle: {
      "padding": "0 20px 10px",
      "position": "relative",
      "z-index": "99999999"
    }
  }, [(_vm.isShowInster) ? _c('p', {
    staticStyle: {
      "margin-bottom": "10px",
      "color": "#4279ff"
    },
    on: {
      "click": _vm.importWxCard
    }
  }, [_vm._v("\n                添加到微信卡包\n            ")]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.isInsert == true) ? _c('p', {
    staticStyle: {
      "margin-bottom": "10px",
      "color": "#4279ff"
    },
    on: {
      "click": _vm.viewWxCard
    }
  }, [_vm._v("\n                查看微信卡包\n            ")]) : _vm._e(), _vm._v(" "), (_vm.imgUrl) ? _c('div', {
    staticClass: "fapiaochoujiang",
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [(_vm.imgUrl) ? _c('a', {
    attrs: {
      "href": _vm.hrefStr
    },
    on: {
      "click": _vm.adPromotioClick
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "btn-new-sty",
    attrs: {
      "type": "warn"
    },
    on: {
      "click": function($event) {
        return _vm.onClick('lookFP')
      }
    }
  }, [_vm._v("\n                查看版式文件\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.source != 'piaotong' && _vm.dataDetail.imgSize === 0) ? _c('x-button', {
    staticClass: "btn-new-sty",
    staticStyle: {
      "margin-top": "20px",
      "width": "calc(100% - 40px)"
    },
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('fpPaiZhao')
      }
    }
  }, [_vm._v("发票拍照")]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.source != 'piaotong' && _vm.dataDetail.imgSize > 0) ? _c('x-button', {
    staticClass: "btn-new-sty",
    staticStyle: {
      "margin": "20px auto"
    },
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('jxFiles')
      }
    }
  }, [_vm._v("\n            查看影像发票文件\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64022bb1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fpj/dzfppz.vue
// module id = 339
// module chunks = 0